import { render, staticRenderFns } from "./edit_fagao.vue?vue&type=template&id=1ebc0b12&scoped=true&"
import script from "./edit_fagao.vue?vue&type=script&lang=js&"
export * from "./edit_fagao.vue?vue&type=script&lang=js&"
import style0 from "./edit_fagao.vue?vue&type=style&index=0&id=1ebc0b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc0b12",
  null
  
)

export default component.exports